import { lazy } from 'react'
import { Route, Routes } from 'react-router-dom'

import RoleMiddleware from '@/components/RoleMiddleware.jsx'
import {
    AUTHOR,
    INTERVENTION_AUTHOR,
    INTERVENTION_EDITOR,
    MENTOR,
    STUDENT_PLUS,
} from '@/enums/userRoles.js'
const Interventions = lazy(() => import('@/deprecated/Interventions/index.jsx'))

const InterventionRouter = (
    <Routes>
        <Route
            index
            element={
                <RoleMiddleware
                    roles={[
                        STUDENT_PLUS,
                        MENTOR,
                        AUTHOR,
                        INTERVENTION_AUTHOR,
                        INTERVENTION_EDITOR,
                    ]}
                >
                    <Interventions />
                </RoleMiddleware>
            }
        />
    </Routes>
)

export default InterventionRouter
